import { render, staticRenderFns } from "./page-provider.vue?vue&type=template&id=1c9d716a&scoped=true"
import script from "./page-provider.vue?vue&type=script&lang=js"
export * from "./page-provider.vue?vue&type=script&lang=js"
import style0 from "./page-provider.vue?vue&type=style&index=0&id=1c9d716a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9d716a",
  null
  
)

export default component.exports